import { INVALID_C_IDENTIFIER_MESSAGE, isValidCIdentifier, isValidCIdentifierFilePath } from '@lved/shared-core';
import { FileStat } from '@theia/filesystem/lib/common/files';
import { injectable } from '@theia/core/shared/inversify';
import { WorkspaceCommandContribution } from '@theia/workspace/lib/browser/workspace-commands';

@injectable()
export class LvglWorkspaceCommandContribution extends WorkspaceCommandContribution {
    protected override async validateFileName(
        name: string,
        parent: FileStat,
        allowNested: boolean = false
    ): Promise<string> {
        const validationMessage: string = await super.validateFileName(name, parent, allowNested);
        if (validationMessage || !name) return validationMessage;

        const pathParts: string[] = name.split(/[\\/]/);
        const nonFinalParts: string[] = pathParts.slice(0, -1);
        const finalPart: string = pathParts[pathParts.length - 1];

        const allNonFinalValid: boolean = nonFinalParts.every((part: string): boolean => isValidCIdentifier(part));
        const finalValid: boolean = isValidCIdentifierFilePath(finalPart);

        return allNonFinalValid && finalValid ? '' : INVALID_C_IDENTIFIER_MESSAGE;
    }
}
